window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let cardSplidePanel = document.querySelectorAll('.card-panel');
    let shopifyCardSplidePanel = document.querySelectorAll('.block-card-panel');

    if (availableCarousels.length) {

        // START TESTIMONIAL PANEL SLIDER
        if (cardSplidePanel.length) {
            for ( let panel of cardSplidePanel ) {
                let parentPanel = panel;
                let currentCardCounter = parentPanel.querySelector('.card-splide-current-slide');
                let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
                let totalSlides = parentPanel.querySelector('.splide').dataset.totalSlides;

                var cardSplide = new Splide(panel.querySelector('.card-splide'), {
                    type: 'slide',
                    perPage: 3,
                    gap: '2rem',
                    perMove: 1,
                    pagination: false,
                    arrows: true,
                    arrowPath: 'M23.7604 24.7323L18.2073 20.0168L23.7604 15.2689C24.523 14.6364 23.2884 13.5599 22.5258 14.1924L16.2099 19.5727C15.9553 19.7947 15.9193 20.2052 16.1739 20.4272L22.5257 25.8075C23.2883 26.44 24.5217 25.3646 23.7603 24.731L23.7604 24.7323Z',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full inset-0 z-3 pointer-events-none',
                        arrow: 'splide__arrow no-tap-to-zoom pointer-events-auto absolute -bottom-40 sm:-bottom-32 lg:-bottom-40 -translate-y-1/2 transition-all duration-300 ease-in-out hover:scale-110 disabled:!scale-100 disabled:opacity-20 fill-pink-desat border border-2 border-green-desat rounded-[200px] w-12 h-[3.25rem]',
                        prev: 'splide__arrow--prev left-6 lg:left-8',
                        next: 'splide__arrow--next right-6 lg:right-8 rotate-180',
                    },
                    padding: { left: 'none', right: 'none' },
                    breakpoints: {
                        1024: {
                            perPage: 2,
                            gap: '2rem'
                        },
                        640: {
                            perPage: 1,
                        }
                    },
                });

                for ( let arrow of navArrows ) {
                    arrow.addEventListener('click', () => {
                        if (arrow.dataset.navigate == '+') {
                            cardSplide.go('+1');
                        } else {
                            cardSplide.go('-1');
                        }
                    });
                }

                cardSplide.on('mounted move', function () {
                    if (currentCardCounter) {
                        const updateIndex = setTimeout(() => {
                            currentCardCounter.textContent = (cardSplide.index + 1).toString();
                            let maxCardsOnScreen = cardSplide.options.perPage;
                            for ( let arrow of navArrows ) {
                                if (arrow.dataset.navigate == '+' && (cardSplide.index + maxCardsOnScreen) == totalSlides) {
                                    arrow.classList.add('!opacity-20');
                                    arrow.setAttribute('disabled', '');
                                } else if (arrow.dataset.navigate == '+') {
                                    arrow.classList.remove('!opacity-20');
                                    arrow.removeAttribute('disabled');
                                }

                                if (arrow.dataset.navigate == '-' && (cardSplide.index + 1) == 1) {
                                    arrow.classList.add('!opacity-20');
                                    arrow.setAttribute('disabled', '');
                                } else if (arrow.dataset.navigate == '-') {
                                    arrow.classList.remove('!opacity-20');
                                    arrow.removeAttribute('disabled');
                                }
                            }
                        }, 50);
                    }
                });

                cardSplide.mount();
            }
        }
        // END TESTIMONIAL PANEL SLIDER

        // START TESTIMONIAL BLOCK PANEL SLIDER
        if (shopifyCardSplidePanel.length) {
            for ( let panel of shopifyCardSplidePanel ) {
                let parentPanel = panel;
                let currentCardCounter = parentPanel.querySelector('.card-splide-current-slide');
                let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
                let totalSlides = parentPanel.querySelector('.splide').dataset.totalSlides;

                var cardSplide = new Splide(panel.querySelector('.card-splide'), {
                    type: 'slide',
                    perPage: 3,
                    gap: '1rem',
                    perMove: 1,
                    pagination: false,
                    arrows: true,
                    arrowPath: 'M23.7604 24.7323L18.2073 20.0168L23.7604 15.2689C24.523 14.6364 23.2884 13.5599 22.5258 14.1924L16.2099 19.5727C15.9553 19.7947 15.9193 20.2052 16.1739 20.4272L22.5257 25.8075C23.2883 26.44 24.5217 25.3646 23.7603 24.731L23.7604 24.7323Z',
                    classes: {
                        arrows: 'splide__arrows absolute w-full h-full inset-0 z-3 pointer-events-none',
                        arrow: 'splide__arrow no-tap-to-zoom pointer-events-auto absolute flex items-center justify-center -bottom-28 sm:-bottom-28 lg:-bottom-28 -translate-y-1/2 transition-all duration-300 ease-in-out hover:scale-110 disabled:!scale-100 disabled:opacity-20 fill-pink-desat border border-2 border-green-desat rounded-[200px] w-12 h-[3.25rem]',
                        prev: 'splide__arrow--prev left-0',
                        next: 'splide__arrow--next right-0 rotate-180',
                    },
                    padding: { left: 'none', right: 'none' },
                    breakpoints: {
                        1024: {
                            perPage: 2,
                            gap: '1rem'
                        },
                        640: {
                            perPage: 1,
                        }
                    },
                });

                for ( let arrow of navArrows ) {
                    arrow.addEventListener('click', () => {
                        if (arrow.dataset.navigate == '+') {
                            cardSplide.go('+1');
                        } else {
                            cardSplide.go('-1');
                        }
                    });
                }

                cardSplide.on('mounted move', function () {
                    if (currentCardCounter) {
                        const updateIndex = setTimeout(() => {
                            currentCardCounter.textContent = (cardSplide.index + 1).toString();
                            let maxCardsOnScreen = cardSplide.options.perPage;
                            for ( let arrow of navArrows ) {
                                if (arrow.dataset.navigate == '+' && (cardSplide.index + maxCardsOnScreen) == totalSlides) {
                                    arrow.classList.add('!opacity-20');
                                    arrow.setAttribute('disabled', '');
                                } else if (arrow.dataset.navigate == '+') {
                                    arrow.classList.remove('!opacity-20');
                                    arrow.removeAttribute('disabled');
                                }

                                if (arrow.dataset.navigate == '-' && (cardSplide.index + 1) == 1) {
                                    arrow.classList.add('!opacity-20');
                                    arrow.setAttribute('disabled', '');
                                } else if (arrow.dataset.navigate == '-') {
                                    arrow.classList.remove('!opacity-20');
                                    arrow.removeAttribute('disabled');
                                }
                            }
                        }, 50);
                    }
                });

                cardSplide.mount();
            }
        }
        // END TESTIMONIAL BLOCK PANEL SLIDER
    }
});
